import { Box } from '@chakra-ui/react'

import {
  CHART_BAR_LEGEND_SWATCH_BORDER_RADIUS,
  CHART_BAR_LEGEND_SWATCH_HEIGHT,
  CHART_BAR_LEGEND_SWATCH_WIDTH,
} from './chart.constants'

export {
  CHART_BAR_LEGEND_SWATCH_WIDTH,
  CHART_BAR_LEGEND_SWATCH_HEIGHT,
} from './chart.constants'

interface ChartBarLegendSwatchProps {
  color: string
}

export const ChartBarLegendSwatch = ({ color }: ChartBarLegendSwatchProps) => (
  <Box
    w={CHART_BAR_LEGEND_SWATCH_WIDTH}
    h={CHART_BAR_LEGEND_SWATCH_HEIGHT}
    borderRadius={CHART_BAR_LEGEND_SWATCH_BORDER_RADIUS}
    bg={color}
    flexShrink={0}
  />
)

/** Compact line-series marker for dense rows (floating tooltip). */
const CHART_LINE_DOT_SIZE = '10px'
const CHART_LINE_DOT_BORDER = '2px solid white'

export type ChartMarkerType = 'bar' | 'line' | 'circle'

export interface ChartMarkerProps {
  type: ChartMarkerType
  color: string
  /**
   * `line` only: `strip` = line + center dot (wider, for legend-style rows).
   * `dot` = small filled dot (floating multi-series tooltip rows).
   */
  linePresentation?: 'strip' | 'dot'
}

export const ChartMarker = ({
  type,
  color,
  linePresentation = 'strip',
}: ChartMarkerProps) => {
  if (type === 'bar') {
    return <ChartBarLegendSwatch color={color} />
  }

  if (type === 'line') {
    if (linePresentation === 'dot') {
      return (
        <Box
          w={CHART_LINE_DOT_SIZE}
          h={CHART_LINE_DOT_SIZE}
          flexShrink={0}
          borderRadius="full"
          bg={color}
          border={CHART_LINE_DOT_BORDER}
        />
      )
    }
    return (
      <svg width={32} height={12} viewBox="0 0 32 12" style={{ flexShrink: 0 }}>
        <line
          x1={0}
          y1={6}
          x2={32}
          y2={6}
          stroke={color}
          strokeWidth={3}
          strokeLinecap="round"
        />
        <circle
          cx={16}
          cy={6}
          r={4}
          fill={color}
          stroke="white"
          strokeWidth={2}
        />
      </svg>
    )
  }

  return (
    <Box
      width="22px"
      height="22px"
      flexShrink={0}
      bg={color}
      border="3px solid"
      borderColor="white"
      borderRadius="full"
    />
  )
}
